// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","LiveBadge":"_3HEtRG","isStandalone":"_1wP-5H","fadeInFrames":"_3yHieK"};